export default __webpack_public_path__ + "static/5_34-005a081117ac37228815f239631e5cd4.png";